import * as React from 'react';
import { FC, ReactElement, ReactNode } from 'react';

import { PullToReload, PullToReloadContent } from 'components/pull-to-reload';

import { LoyaltyLoadingAnimation, LoyaltyPullDownLoader } from '../loyalty-lottie-animations';

interface ILoyaltyPullToReload {
  onRefresh(): Promise<any>;
  enabled?: boolean;
  refreshContent?: ReactElement;
  children?: ReactNode;
}

export const LoyaltyPullToReload: FC<ILoyaltyPullToReload> = ({
  onRefresh,
  children,
  enabled,
  refreshContent,
}) => {
  return (
    <PullToReload
      pullDownThreshold={200}
      triggerHeight={500}
      startInvisible
      enabled={enabled}
      onRefresh={onRefresh}
      pullDownContent={
        <PullToReloadContent action="pullingDown" animationData={LoyaltyPullDownLoader} />
      }
      releaseContent={
        <PullToReloadContent action="releasing" animationData={LoyaltyPullDownLoader} />
      }
      refreshContent={
        refreshContent ?? (
          <PullToReloadContent action="refreshing" animationData={LoyaltyLoadingAnimation} />
        )
      }
    >
      {children}
    </PullToReload>
  );
};
